import Nullstack from 'nullstack';
export default function IconBuilding({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-building",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("line", {
    x1: "3",
    y1: "21",
    x2: "21",
    y2: "21"
  }), "   ", Nullstack.element("line", {
    x1: "9",
    y1: "8",
    x2: "10",
    y2: "8"
  }), "   ", Nullstack.element("line", {
    x1: "9",
    y1: "12",
    x2: "10",
    y2: "12"
  }), "   ", Nullstack.element("line", {
    x1: "9",
    y1: "16",
    x2: "10",
    y2: "16"
  }), "   ", Nullstack.element("line", {
    x1: "14",
    y1: "8",
    x2: "15",
    y2: "8"
  }), "   ", Nullstack.element("line", {
    x1: "14",
    y1: "12",
    x2: "15",
    y2: "12"
  }), "   ", Nullstack.element("line", {
    x1: "14",
    y1: "16",
    x2: "15",
    y2: "16"
  }), "   ", Nullstack.element("path", {
    d: "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16"
  }), " ");
}